import React, { useState, useEffect, useContext } from "react";

import { Dropdown } from "antd";

import { FiltersContext } from "../../../../context/Filters";

import { WhitePersonIcon, BlackPersonIcon } from "../../../Reusable/Icons";
import Menu from "./Menu";

import styles from "../filter.module.scss";

const User = ({ username }) => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("Source");

  const { filters, setFilter, removeFilter } = useContext(FiltersContext);

  useEffect(() => {
    const parameters = filters.username;
    if (!!parameters?.length) {
      setText(`Filtered by ${parameters.length}`);
    } else {
      setText("User");
    }
  }, [filters]);
  return (
    <Dropdown
      overlay={
        <Menu
          closeDropdown={setVisible}
          setFilter={setFilter}
          removeFilter={removeFilter}
          defaultValue={filters.username}
          options={username?.values?.split(",")}
        />
      }
      getPopupContainer={(trigger) => {
        return trigger.parentNode;
      }}
      trigger="click"
      visible={visible}
      placement="bottomCenter"
      overlayStyle={{ height: "100%" }}
      onVisibleChange={(v) => setVisible(v)}
    >
      <div
        className={`${styles.filterContainer} ${
          !!filters.username?.length ? styles.active : ""
        }`}
      >
        {!!filters.username?.length ? (
          <WhitePersonIcon fill="white" />
        ) : (
          <BlackPersonIcon fill="black" />
        )}
        {text}
      </div>
    </Dropdown>
  );
};

export default User;
